import { FC, useEffect, useState } from 'react'
import styled from 'styled-components'

import { PageWrapper } from '../../components/PageWrapper'
import { ErrorComponent } from '../ErrorComponent'
import { ERROR_CODE_TO_REFERENCE } from '../OpenBankingErrorPage'

import { useQuery, useTracking } from 'utils'

export const TimeoutPage: FC = () => {
  const query = useQuery()

  const [loaded, setLoaded] = useState(false)
  const [errorReference, setErrorReference] = useState(undefined as string | undefined)

  useTracking('Timeout', { isFetched: loaded })
  useEffect(() => {
    setTimeout(() => {
      setLoaded(true)
    }, 300)
  }, [])

  useEffect(() => {
    const errorReference = query.get('errorReference')

    setErrorReference(
      errorReference ? errorReference : ERROR_CODE_TO_REFERENCE.get('session_expired'),
    )
  }, [query])

  return (
    <PageWrapper>
      <Content $show={loaded}>
        <ErrorComponent
          description="Oh dear. Looks like you forgot about us for a little too long, or you're using a different browser. Start again on our homepage, or go back to the comparison site and click on us again."
          title="Your session has expired"
          errorReference={errorReference}
        />
      </Content>
    </PageWrapper>
  )
}

interface IContent {
  $show: boolean
}

const Content = styled.div<IContent>`
  display: flex;
  flex-direction: column;
  margin-top: 70px;
  align-items: center;
  transform: ${(props) => (props.$show ? 'translateY(0)' : 'translateY(100vh)')};
  transition: all ease-in-out 0.6s;

  @media (min-width: 768px) {
    margin-top: 140px;
  }
`
